export default "__VITE_ASSET__3ba40e41__"